import { useTranslation } from 'react-i18next';
import { useGetCompanyCardData } from './helpers';
import Loader from 'components/Loader/Loader';
import { CompanyConfigurationCard } from './CompanyConfigurationCard/CompanyConfigurationCard';
import { EditCompanyDataModal } from './EditCompanyDataModal/EditCompanyDataModal';
import { useState } from 'react';
import { EditSupplierSettingsModal } from './EditSupplierSettingsModal/EditSupplierSettingsModal';
import {
  Container,
  Heading,
  InsideWrapper,
  Wrapper,
} from './CompanyManagementPage.styled';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { useGetCompany } from './hooks';
import { usePageTitle } from 'utils/hooks/usePageTitle';
import { EditBuyerSettingsModal } from './EditBuyerSettingsModal/EditBuyerSettingsModal';
import { CompanyRole } from 'types/Company.types';

const CompanyManagementPage = () => {
  const { t } = useTranslation();
  const [isEditSupplierSettingsModalOpen, setIsEditSupplierSettingsModalOpen] =
    useState<boolean>(false);
  const [isEditCompanyDataModalOpen, setIsEditCompanyDataModalOpen] =
    useState<boolean>(false);
  const [isEditBuyerSettingsModalOpen, setIsEditBuyerSettingsModalOpen] =
    useState<boolean>(false);
  const { company } = useSelector((state: IRootReducerState) => state.userInfo);

  const { data, isLoading: isLoadingGetCompany } = useGetCompany(company.id);

  const {
    companyConfigurationLeftData,
    companyConfigurationRightData,
    supplierSettingsLeftData,
    supplierSettingsRightData,
    buyerSettingsLeftData,
  } = useGetCompanyCardData(data, t);

  usePageTitle(t('Company Management'), true);

  return (
    <Container>
      <Heading>{t('Company Management')}</Heading>
      {isLoadingGetCompany ? (
        <Loader />
      ) : (
        <Wrapper>
          <CompanyConfigurationCard
            cardTitle={t('Company data')}
            leftData={companyConfigurationLeftData}
            rightData={companyConfigurationRightData}
            leftSubtitle={t('Details')}
            rightSubtitle={t('Address')}
            onEditClick={() => setIsEditCompanyDataModalOpen(true)}
            logoUrl={data?.logo_url}
            hasLogoCard
          />
          <InsideWrapper>
            {[CompanyRole.BOTH, CompanyRole.SELLER].includes(company?.role) && (
              <CompanyConfigurationCard
                cardTitle={t('Supplier settings')}
                leftData={supplierSettingsLeftData}
                rightData={supplierSettingsRightData}
                onEditClick={() => setIsEditSupplierSettingsModalOpen(true)}
              />
            )}
            {[CompanyRole.BOTH, CompanyRole.BUYER].includes(company?.role) && (
              <CompanyConfigurationCard
                cardTitle={t('Buyer settings')}
                leftData={buyerSettingsLeftData}
                rightData={{}}
                onEditClick={() => setIsEditBuyerSettingsModalOpen(true)}
              />
            )}
          </InsideWrapper>
        </Wrapper>
      )}
      {isEditCompanyDataModalOpen && (
        <EditCompanyDataModal
          isOpen={isEditCompanyDataModalOpen}
          setIsOpen={setIsEditCompanyDataModalOpen}
          onCancel={() => setIsEditCompanyDataModalOpen(false)}
          data={data}
        />
      )}
      {isEditSupplierSettingsModalOpen && (
        <EditSupplierSettingsModal
          data={data}
          isOpen={isEditSupplierSettingsModalOpen}
          setIsOpen={setIsEditSupplierSettingsModalOpen}
          onCancel={() => setIsEditSupplierSettingsModalOpen(false)}
        />
      )}

      {isEditBuyerSettingsModalOpen && (
        <EditBuyerSettingsModal
          data={data}
          isOpen={isEditBuyerSettingsModalOpen}
          setIsOpen={setIsEditBuyerSettingsModalOpen}
          onCancel={() => setIsEditBuyerSettingsModalOpen(false)}
        />
      )}
    </Container>
  );
};

export default CompanyManagementPage;
